<template>
  <v-chart :option="option" autoresize style="width:100%;height:100%;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

export interface AlertCategory {
  name: string;
  count: number;
}

const props = defineProps<{ categories: AlertCategory[] }>();

const option = computed(() => {
  const C = useChartTheme();
  const palette = [C.warn, C.accent, C.muted, C.good, C.bad];
  return {
    backgroundColor: 'transparent',
    series: [{
      type: 'pie',
      radius: ['38%', '62%'],
      center: ['50%', '54%'],
      label: { show: false },
      data: props.categories.map((cat, i) => ({
        value: cat.count,
        name: cat.name,
        itemStyle: { color: palette[i % palette.length] },
      })),
    }],
  };
});
</script>
